import { InjectionToken } from '@angular/core';

import type { StoreConfig } from '@ngrx/store';

import { createProviderToken } from '@core/common-legacy';
import type { SingleEntityState } from '@core/ngrx-legacy';
import { TellentDevFlag, TellentDevFlagsMap } from '@core/tellent-types';

export const buildFlagsMap = (flags: TellentDevFlag[]): TellentDevFlagsMap =>
  Object.values(TellentDevFlag).reduce(
    (map, key) => {
      map[key] = flags.includes(key);
      return map;
    },
    <TellentDevFlagsMap>{},
  );

export const buildEmptyMap = (): TellentDevFlagsMap =>
  Object.values(TellentDevFlag).reduce(
    (map, key) => {
      map[key] = false;
      return map;
    },
    <TellentDevFlagsMap>{},
  );

export const INITIAL_STATE: SingleEntityState<TellentDevFlagsMap> = {
  data: buildEmptyMap(),
  loaded: false,
  pending: false,
  failed: false,
  error: undefined,
};

export const { provide: provideTellentDevFlags, inject: injectTellentDevFlags } =
  createProviderToken<TellentDevFlagsMap>('TELLENT_DEV_FLAGS')();

export const TellentDevFlagConfigToken = new InjectionToken('DevFlagConfigToken', {
  providedIn: 'root',
  factory: (): StoreConfig<SingleEntityState<TellentDevFlagsMap>> => {
    const preloadedFlags = injectTellentDevFlags({ optional: true });
    return preloadedFlags
      ? {
          initialState: {
            loaded: true,
            failed: false,
            pending: false,
            error: false,
            data: preloadedFlags,
          },
        }
      : { initialState: INITIAL_STATE };
  },
});
